import React from "react";
import CommonTextArea from "../../../components/forms/CommonTextArea";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInput from "../../../components/forms/CommonInput";
import CommonInputDecimal from "../../../components/forms/CommonInputDecimal";
import CommonCheckboxSimNao from "../../../components/forms/CommonCheckboxSimNao";
import {
  handleChange,
  handleChangeCheck,
  handleChangeNameValue,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function DadosCobranca({ valuesHook }) {
  const { values, setValues } = valuesHook;
  const tiposJuros = useTipos("tipos_juros");
  const tiposMulta = useTipos("tipos_multa");
  const tiposVencimento = useTipos("tipos_vencimento");

  return (
    <>
      <h5 className="card-title mb-3">Dados de cobrança</h5>
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonTextArea
            label="Descrição do serviço prestado"
            id="descricao_servico_prestado"
            value={values.descricao_servico_prestado}
            onChange={(e) => handleChange(e, values, setValues)}
            rows="1"
            maxlength="256"
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonSelect
            label="Tipo de vencimento"
            id="tipo_vencimento"
            value={values.tipo_vencimento}
            onChange={(e) => handleChange(e, values, setValues)}
            data={tiposVencimento.map((vencimento) => ({
              text: vencimento.valor,
              id: vencimento.chave,
            }))}
            placeholder="Selecione o tipo"
          />
        </div>
        <div className="col-md-2 mb-3">
          <CommonInput
            label="Dia do vencimento"
            id="dia"
            value={values.dia}
            onChange={(e) => handleChangeNumeral(e, values, setValues, 1, 31)}
          />
        </div>
        <div className="col d-flex justify-content-center mb-3">
          <CommonCheckboxSimNao
            label="Emitir NFS-e"
            id="emitir_nfse"
            value={values.emitir_nfse}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
          />
        </div>
        <div className="col d-flex justify-content-center mb-3">
          <CommonCheckboxSimNao
            label="Enviar E-mail"
            id="enviar_email"
            value={values.enviar_email}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col d-flex justify-content-center mb-3">
          <CommonCheckboxSimNao
            label="Multa e juros"
            id="multas_juros"
            value={values.multas_juros}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
          />
        </div>
        <div className="col-md-2 mb-3">
          <CommonSelect
            label="Tipo de multa"
            id="tipo_multa"
            value={values.tipo_multa}
            onChange={(e) => handleChange(e, values, setValues)}
            data={tiposMulta.map((multa) => ({
              text: multa.valor,
              id: multa.chave,
            }))}
            placeholder="Selecione o tipo"
          />
        </div>
        <div className="col-md-2 mb-3">
          <CommonInputDecimal
            label="Multa"
            id="multa"
            value={values.multa}
            onChange={(value) => {
              handleChangeNameValue(
                "multa",
                value.floatValue,
                values,
                setValues
              );
            }}
          />
        </div>
        <div className="col-md-2 mb-3">
          <CommonSelect
            label="Tipo de juros"
            id="tipo_juros"
            value={values.tipo_juros}
            onChange={(e) => handleChange(e, values, setValues)}
            data={tiposJuros.map((juros) => ({
              text: juros.valor,
              id: juros.chave,
            }))}
            placeholder="Selecione o tipo"
          />
        </div>
        <div className="col-md-2 mb-3">
          <CommonInputDecimal
            label="Juros"
            id="juros"
            value={values.juros}
            onChange={(value) => {
              handleChangeNameValue(
                "juros",
                value.floatValue,
                values,
                setValues
              );
            }}
          />
        </div>
        <div className="col-md-2"></div>
      </div>
    </>
  );
}

DadosCobranca.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
};

export default DadosCobranca;
